import {registerStyle, styleRule, UI} from "../../../../../../stem-core/src/ui/UI";
import {StyleSheet} from "../../../../../../stem-core/src/ui/UI";
import {Messages} from "../../../../../Messages";
import {BUTTON_TYPE} from "../../../../../Constants";

import {SubscribeButton} from "./SubscribeButton";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {CoveragePreview} from "./CoveragePreview";
import {isSmallScreen} from "../../../../../UtilsLib";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {SUBSCRIBE_PLAN_STATE} from "../../../../flows/SubscriptionPlanController.js";
import {Controller} from "../../../../flows/Controller.js";
import {SubscriptionFlowHandler} from "../../../../flows/SubscriptionFlowHandler.js";


class SubscriptionCoverageCardStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        flexDirection: "column",
        width: isSmallScreen() ? 326 : 350,
        background: this.themeProps.MERCHANT_CARD_BACKGROUND,
        padding: "18px 24px 24px",
        border: "1px solid " + this.themeProps.MERCHANT_CARD_BORDER_COLOR,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        boxShadow: this.themeProps.MERCHANT_CARD_BOX_SHADOW,
    };

    @styleRule
    buttonsContainer = {
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-end",
        width: "100%",
        marginTop: "auto",
        ">:not(:first-child)": {
            marginTop: 10,
        }
    }
}

@registerStyle(SubscriptionCoverageCardStyle)
export class SubscriptionCoverageCard extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            coverage: null,
            onSubscriptionOfferSelected: NOOP_FUNCTION,
            testId: "subscriptionCoverageCard",
        };
    }

    getFormattedSubscriptionOfferPrice(offer) {
        return `${SubscriptionFlowHandler.getSubscriptionOfferPrice(offer, Controller.subscriptionPlan.getDiscountInfo(offer))}/${offer.getCycleDuration(true)}`
    }

    getOfferLabel(offer) {
        const formattedPrice = this.getFormattedSubscriptionOfferPrice(offer);

        if (Controller.subscriptionPlan.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.giftSubscription) {
            return Messages.giftSubscriptionButtonLabel(formattedPrice);
        }

        if (Controller.subscriptionPlan.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.subscribe) {
            const subscriptionOffers = this.options.coverage.getAvailableOffers();

            return subscriptionOffers.length > 1 ? Messages.subscribeInlineFlowButton(formattedPrice) : Messages.subscribe
        }

        return this.userHasEquivalentSubscription(offer) ? Messages.subscribedButtonLabel(formattedPrice) : Messages.changePlanButtonLabel(formattedPrice);
    }

    userHasEquivalentSubscription(offer) {
        if (Controller.subscriptionPlan.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.giftSubscription) {
            return false;
        }

        if (Controller.subscriptionPlan.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.subscribe) {
            return false;
        }

        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        return !!activeSubscription && activeSubscription.billingPlan === offer.billingPlan && activeSubscription.coverage === offer.coverage;
    }

    render() {
        const {styleSheet} = this;
        const {coverage, onSubscriptionOfferSelected} = this.options;
        const subscriptionOffers = coverage.getAvailableOffers();

        if (subscriptionOffers.length === 0) {
            return null;
        }

        return [
            <CoveragePreview coverage={coverage} subscriptionOffers={subscriptionOffers}/>,
            <div className={styleSheet.buttonsContainer}>
                {
                    subscriptionOffers.map((offer, index) => <SubscribeButton
                        type={index ? BUTTON_TYPE.SECONDARY : BUTTON_TYPE.PRIMARY}
                        offer={subscriptionOffers[0]}
                        disabled={this.userHasEquivalentSubscription(offer)}
                        onClick={() => onSubscriptionOfferSelected(offer)}
                        label={this.getOfferLabel(offer)}
                    />)
                }
            </div>
        ];
    }
}
